import { useState } from 'react';

/**
 * The unit card for a single sticker in the main grid.
 * Handles its own collect/uncollect animation, keyboard a11y, and the
 * inline +/− duplicates controls.
 */
export default function StickerCard({
  sticker,
  collected,
  duplicates,
  onToggle,
  onDupChange,
  isHighlighted,
  rarity,
  incoming = false,
}) {
  const dupes = duplicates || 0;
  const isRare = rarity !== undefined && rarity < 15 && rarity > 5;
  const isLegendary = rarity !== undefined && rarity < 5;
  const isValuable = (isRare || isLegendary) && dupes > 0;
  const [animClass, setAnimClass] = useState('');

  const handleClick = () => {
    setAnimClass(collected ? 'sticker-uncollect' : 'sticker-pop');
    setTimeout(() => setAnimClass(''), 350);
    onToggle(sticker.number);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      id={`sticker-${sticker.number}`}
      className={`sticker-card ${collected ? 'collected' : ''} ${incoming && !collected ? 'incoming' : ''} ${sticker.type}-type ${isHighlighted ? 'highlighted' : ''} ${isRare ? 'rare-glow' : ''} ${isLegendary ? 'legendary-glow' : ''} ${animClass}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-pressed={collected}
      aria-label={`Lámina ${sticker.number}, ${sticker.label}${collected ? ', coleccionada' : ''}${incoming && !collected ? ', apartada por intercambio' : ''}${dupes > 0 ? `, ${dupes} repetida${dupes > 1 ? 's' : ''}` : ''}`}
    >
      <div className="check-icon">✓</div>
      {incoming && !collected && (
        <div
          className="incoming-badge"
          title="Apartada por un trato reservado — pronto la recibes"
          aria-hidden="true"
        >
          🔒
        </div>
      )}
      <div className="sticker-number">{sticker.number}</div>
      <div className="sticker-name">{sticker.label}</div>
      {rarity !== undefined && (
        <div className="sticker-rarity-tag">{rarity}%</div>
      )}
      {isValuable && (
        <div style={{
          position: 'absolute', bottom: '30px', left: '6px',
          fontSize: '0.55rem', background: 'rgba(234, 179, 8, 0.2)',
          color: 'var(--accent-gold)', padding: '1px 4px', borderRadius: '3px',
          fontWeight: 800, border: '1px solid rgba(212, 168, 67, 0.3)',
        }}>VALIOSA</div>
      )}
      {collected && (
        <div className="dup-controls" onClick={e => { e.preventDefault(); e.stopPropagation(); }}>
          <button
            className="dup-btn"
            aria-label={`Quitar repetida de lámina ${sticker.number}`}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onDupChange(sticker.number, dupes - 1); }}
          >−</button>
          <span className="dup-count" aria-live="polite">{dupes}</span>
          <button
            className="dup-btn"
            aria-label={`Agregar repetida de lámina ${sticker.number}`}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onDupChange(sticker.number, dupes + 1); }}
          >+</button>
        </div>
      )}
    </div>
  );
}
